var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ActivityItem", {
    attrs: {
      activity: _vm.activity,
      project: _vm.project,
      redirectToContractor: true,
      frozen: _vm.project.completed,
      currentUserId: _vm.currentUserId,
      companyId: _vm.companyId,
      processing: _vm.processing,
      approvedTimesSum: _vm.approvedTimesSum,
      moreHoursRequest: _vm.moreHoursRequest,
    },
    on: {
      activityDeleted: function ($event) {
        return _vm.$emit("activityDeleted", $event)
      },
      activityUpdated: function ($event) {
        return _vm.$emit("activityUpdated", $event)
      },
      activityCompleted: function ($event) {
        return _vm.$emit("activityCompleted", $event)
      },
      activityReopened: function ($event) {
        return _vm.$emit("activityReopened", $event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "secondaryBlock",
        fn: function () {
          return [
            _vm.activity.confirmed_hours
              ? _c("CardBodyItem", {
                  attrs: {
                    label: "Estimated hours",
                    content: _vm.convertSecondsToReadable(
                      _vm.activity.confirmed_hours
                    ),
                  },
                })
              : _vm._e(),
            _c("CardBodyItem", {
              attrs: {
                label: "Approved hours",
                content: _vm.convertSecondsToReadable(_vm.approvedTimesSum),
              },
            }),
            _c("CardBodyItem", {
              attrs: {
                label: "Requested hours",
                content: _vm.convertSecondsToReadable(_vm.moreHoursRequest),
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }